import React from 'react';
import LegalLayout from '../components/LegalLayout';

const DracoGermanSupport: React.FC = () => {
  return (
    <LegalLayout title="DracoGerman Support" lastUpdated="October 7, 2026">
      <p>
        Need help with DracoGerman, found a bug, or have a suggestion? Reach us at{' '}
        <a href="mailto:service@spiegeleistudio.com">service@spiegeleistudio.com</a> and
        we'll get back to you as soon as we can.
      </p>

      <h2>Frequently Asked Questions</h2>

      <h3>Do I need an account?</h3>
      <p>
        No. Vocabulary, flashcards, podcasts, and the training exercises all work without
        signing in. An account is only needed for pronunciation scoring, AI analysis in Live
        Listening, and a Premium subscription.
      </p>

      <h3>What does Premium include?</h3>
      <p>
        Premium raises the daily limits for pronunciation scoring and for AI analysis in Live
        Listening. The current limits are shown in the app before you subscribe. All learning
        content stays free.
      </p>

      <h3>How do I cancel my subscription?</h3>
      <p>
        Subscriptions are managed by Apple. Open the Settings app on your iPhone, tap your
        name, then Subscriptions, and select DracoGerman. In the app you can also go to
        Account and tap your Premium status. Your Premium access continues until the end of
        the period you already paid for.
      </p>

      <h3>I subscribed, but the app still shows the free plan.</h3>
      <p>
        Make sure you are signed in with the same account you used when subscribing, then
        open Account, tap Upgrade to Premium, and choose Restore purchases. If that does not
        help, email us with the email address of your account.
      </p>

      <h3>How do I get a refund?</h3>
      <p>
        Refunds for App Store purchases are handled by Apple. You can request one at{' '}
        <a href="https://reportaproblem.apple.com">reportaproblem.apple.com</a>.
      </p>

      <h3>Will I lose my progress if I switch phones?</h3>
      <p>
        Your learning progress and settings are stored only on your device (see our{' '}
        <a href="/dracogerman/privacy">Privacy Policy</a>), so they are not transferred
        automatically to a new device. Your account and subscription are, once you sign in.
      </p>

      <h3>Can I use the app offline?</h3>
      <p>
        Yes. The learning content is kept on your device, and you can download word audio
        from the vocabulary list for offline use. Pronunciation scoring and AI analysis need
        an internet connection.
      </p>

      <h3>Live Listening does not pick up any text.</h3>
      <p>
        Check that DracoGerman has microphone access in your device settings, that the German
        audio is playing through a speaker near your phone rather than headphones, and that
        the volume is high enough.
      </p>

      <h3>How do I delete my account?</h3>
      <p>
        Open Account in the app, scroll to the bottom, and tap Delete account. This cannot be
        undone. If you have a running subscription, cancel it separately in your App Store
        settings.
      </p>

      <h3>I found a mistake in a word or translation.</h3>
      <p>
        Please email us at{' '}
        <a href="mailto:service@spiegeleistudio.com">service@spiegeleistudio.com</a> with the
        word and what looks wrong. We correct content without requiring an app update.
      </p>
    </LegalLayout>
  );
};

export default DracoGermanSupport;
